<template>
  <div>
    <transition name="fade-transform" mode="out-in">
<!--      <keep-alive :include="cachedViews">-->
        <router-view/>
<!--      </keep-alive>-->
    </transition>
  </div>
</template>
<script>
export default {
  name: 'EmptyIndex',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    }
  }
}
</script>
